import styled from 'styled-components';
import { noop } from 'lodash';
import { connect } from '@ardoq/rxbeach';
import { Box } from '@ardoq/layout';
import { ComponentSelectorPane } from '@ardoq/component-hierarchies';
import { space } from '@ardoq/design-tokens';
import { SEARCH_BOX_ATTRIBUTE } from './consts';
import {
  noodleSearchBoxProps$,
  NoodleSearchBoxProps,
  noodleSearchPaneProps$,
  NoodleSearchPaneProps,
} from './noodleSearchBoxProps$';

const FloatingContainer = styled(Box)<{ $isIdle: boolean }>`
  top: ${space.medium};
  right: ${space.medium};
  width: 360px;
  height: ${({ $isIdle }) => ($isIdle ? 'auto' : '400px')};
`;

const NO_IDS: string[] = [];

const NoodleSearchPaneBase = ({
  isIdle,
  searchLabel,
  placeholder,
  searchHintMessage,
  locale,
  i18nLocale,
  onScopeDataLoaded,
  filterTerm,
  onFilterTermChange,
  query,
}: NoodleSearchPaneProps) => (
  <FloatingContainer
    {...{ [SEARCH_BOX_ATTRIBUTE]: true }}
    role="search"
    aria-label={searchLabel}
    position="absolute"
    zIndex={2}
    backgroundColor="bgDefault"
    borderRadius="medium"
    boxShadow="shadowL"
    $isIdle={isIdle}
  >
    <ComponentSelectorPane
      componentQuery={query}
      searchHintMessage={searchHintMessage}
      isResultListHidden={isIdle}
      initialTreeConfiguration={{ filterTerm }}
      onFilterTermChange={onFilterTermChange}
      onComponentsSelected={noop}
      selectedIds={NO_IDS}
      disabledOptions={NO_IDS}
      placeholderText={placeholder}
      locale={locale}
      i18nLocale={i18nLocale}
      autoFocus
      isMultiselectable={false}
      areNonMatchingResultsSelectable
      hideWorkspaceFilter
      onScopeDataLoaded={onScopeDataLoaded}
      isAsyncSearch
    />
  </FloatingContainer>
);

const NoodleSearchPane = connect(NoodleSearchPaneBase, noodleSearchPaneProps$);

const NoodleSearchBoxBase = ({ isVisible }: NoodleSearchBoxProps) => {
  if (!isVisible) return null;
  return <NoodleSearchPane />;
};

export const NoodleSearchBox = connect(
  NoodleSearchBoxBase,
  noodleSearchBoxProps$
);
